"use client";

import { useEffect } from "react";
import { track } from "@/lib/analytics/tracker";
import { useListingActionSettled } from "./listing-action-resolution";
import type { ProductDetail } from "./types";
import { ListingQuoteRequestForm } from "./listing-quote-request-form";
import {
  getInitialQuoteDeliveryDate,
  getInitialQuoteQuantity,
} from "./listing-action-state";
import { useDeliveryLocation } from "@/hooks/checkout/useDeliveryLocation";
import { useListingQuery } from "./listing-query";

export function ListingGuestQuoteRequest({ data }: { data: ProductDetail }) {
  const searchParams = useListingQuery();
  const { location, isLoading: isRestoringDelivery } = useDeliveryLocation();
  const isSettled = useListingActionSettled();
  useEffect(() => {
    if (isSettled) track("listing.gate_shown", { productId: data._id, gate: "guest_quote_form" });
  }, [data._id, isSettled]);

  return (
    <ListingQuoteRequestForm
      key={isRestoringDelivery ? "restoring" : "restored"}
      data={data}
      guest
      restorePendingCodeStep={!isRestoringDelivery}
      initialQuantity={getInitialQuoteQuantity(
        searchParams.get("qty") ?? undefined,
        data.minOrderQuantity || 1,
      )}
      initialDeliveryDate={getInitialQuoteDeliveryDate(
        searchParams.get("deliveryDate") ?? undefined,
        data.leadTimeDays ?? 0,
      )}
      initialLine1={location?.line1 ?? undefined}
      initialLine2={location?.line2 ?? undefined}
      initialCity={location?.city}
      initialState={location?.state}
      initialZip={location?.zip}
      initialCountry="US"
    />
  );
}
